
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

import DeptDialog from '@/components/DeptDialog/index.vue';
import DeptLevel from '@/components/DeptLev/index.vue';
import FaultDialog from '@/components/FaultDialog/index.vue';
import CustomerDialog from "@/components/CustomerDialog/levelByLevel.vue";
import OrderBrand from "../../order/components/OrderBrand.vue";
import InstallSourceDialog from "@/components/InstallSourceDialog/InstallSourceDialog.vue";
import OrderTag from '@/views/order/components/OrderTag.vue';
import DialogEngineer from '@/views/statistics/components/DialogSelectEngineer.vue';
import { ViewType } from '@/types/orderServicer';

const orderStatusOptions = [
  {
    value: "1",
    label: "待处理",
  },
  {
    value: "2",
    label: "进行中",
  },
  {
    value: "3",
    label: "上报中",
  },
  {
    value: "4",
    label: "挂单中",
  },
  {
    value: "5",
    label: "完结单",
  },
];
const orderTypeOptions = [
  {
    label: "其他",
    value: 1,
  },
  {
    label: "维保",
    value: 2,
  },
  {
    label: "安装",
    value: 3,
  },
  {
    label: "巡检",
    value: 4,
  },
];
const orderResourceOptions = [
  {
    label: "内部订单",
    value: 1,
  },
  {
    label: "外部订单",
    value: 2,
  },
  {
    label: "转入订单",
    value: 3,
  },
  {
    label: "转出订单",
    value: 4,
  },
  {
    label: "退回订单",
    value: 5,
  },
];
const finishStateOptions = [
  {
    label: "请选择",
    value: 0,
  },
  {
    label: "正常完成",
    value: 1,
  },
  {
    label: "关闭",
    value: 2,
  },
];
const pollingStateOptions = [
  {
    label: "正常",
    value: 1,
  },
  {
    label: "异常",
    value: 2,
  },
];
const underwayOrderStateOptions = [
  {
    label: "正常",
    value: "1",
  },
  {
    label: "上报中",
    value: "3",
  },
  {
    label: "挂单中",
    value: "4",
  },
];
const orderEvaluateOptions = [
  {
    label: "已评价",
    value: 7,
  },
  {
    label: "未评价",
    value: 6,
  },
  {
    label: "= 5星",
    value: 5,
  },
  {
    label: "≤ 4星",
    value: 4,
  },
  {
    label: "≤ 3星",
    value: 3,
  },
  {
    label: "≤ 2星",
    value: 2,
  },
  {
    label: "1星",
    value: 1,
  },
];
const orderVerificationOptions = [
  {
    label: "未核销",
    value: 2,
  },
  {
    label: "已核销",
    value: 1,
  },
];
const chargeOptions = [
  {
    label: "有费用",
    value: 1,
  },
  {
    label: "无费用",
    value: 0,
  },
];
const taskOptions = [
  {
    label: "未完成",
    value: 1,
  },
  {
    label: "已完成",
    value: 2,
  },
  {
    label: "所有任务已完成",
    value: 3,
  },
];

@Component({
  name: 'OrderServicerSearchCustomItem',
  components: {
    DeptDialog,
    DeptLevel,
    FaultDialog,
    CustomerDialog,
    OrderBrand,
    InstallSourceDialog,
    OrderTag,
    DialogEngineer
  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {}
  })
  searchData!: any;
  @Prop({
    default: ViewType.ORDER_SERVICER,
    validator: (value) => ViewType !== undefined,
  })
  private viewType?: ViewType;

  private orderStatusOptions = orderStatusOptions;
  private orderTypeOptions = orderTypeOptions;
  private orderResourceOptions = orderResourceOptions;
  private finishStateOptions = finishStateOptions;
  private pollingStateOptions = pollingStateOptions;
  private underwayOrderStateOptions = underwayOrderStateOptions;
  private orderEvaluateOptions = orderEvaluateOptions;
  private orderVerificationOptions = orderVerificationOptions;
  private chargeOptions = chargeOptions;
  private taskOptions = taskOptions;
  private params: object = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0'
  }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

private serverCompanyId=''
created() {
  this.serverCompanyId = UserModule.getCompanyId;
}

  //服务部门
  private servicerdeptReadonly = false;
  private servicerDeptHasSub = false;
  private deptType = 9;
  private departmentVisible = false;
  @Watch("departmentVisible")
  getDepartmentVisible(val: boolean) {
    if (val) {
      this.servicerdeptReadonly = true;
    } else {
      this.servicerdeptReadonly = false;
    }
  }
  private selectedRepairDeptHandle() {
    this.departmentVisible = true;
    this.deptType = 1;
  }
  private selectedServicerDeptHandle() {
    this.departmentVisible = true;
    this.deptType = 2;
  }
  departmentSelected(val: any) {
    // if (this.deptType === 1) {
    //   this.orderForm.customerDeptName = val.name;
    //   this.orderForm.customerDeptId = val.dept_id;
    // } else {
    //   this.orderForm.servicerDeptName = val.name;
    //   this.orderForm.servicerDeptId = val.dept_id;
    // }
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.dept_id;
    this.searchData.fields.hasSubServicerDept = this.servicerDeptHasSub;
    this.changeData();
  }
  departmentDialogClose(value: any) {
    this.departmentVisible = value;
  }
  private clearDept() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.searchData.fields.hasSubServicerDept = false;
    this.changeData();
  }

  private handleChangeServicerDeptHasSub(value: boolean) {
    this.searchData.fields.hasSubServicerDept = value;
    this.changeData();
  }

   // 报修部门
  private cusDeptType= 9;//9所有部门
  private cusDeptIsMulti= 1;
  private cusDeptHasSub = false;
  private dialogDeptLevelVisible=false
  private selcetedDeptLevel:any = null;
  private tmpSelcetedDeptLevel:any = null;
  private showDialogDeptLevel() {
    this.dialogDeptLevelVisible = true;
    //响应上级重置事件
   if( !(this.searchData.fields && this.searchData.fields.name && this.searchData.fields.name.length>0) ){
      this.selcetedDeptLevel =null;
    }
    this.tmpSelcetedDeptLevel = this.selcetedDeptLevel ? [...this.selcetedDeptLevel] : null;
  }
  private handleChangeDeptLevel(value:any) {
    this.tmpSelcetedDeptLevel = value;
    // this.formAdd.userDept = value;
  }

  private  clearDialogDeptLevel() {
    this.selcetedDeptLevel =  null;
    this.tmpSelcetedDeptLevel = null;
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.searchData.fields.hasSubCustomerDept = false;
    this.changeData();
  }

  private handleChangeCusDeptHasSub(value:boolean){
    this.searchData.fields.hasSubCustomerDept = value;
    this.changeData();
  }
  
  private handleConfirmDialogDeptLevel() {
    this.selcetedDeptLevel = this.tmpSelcetedDeptLevel ? [...this.tmpSelcetedDeptLevel] : null;
    this.dialogDeptLevelVisible = false;
    let deptIds = '';
    let deptNames = '';
    this.selcetedDeptLevel.forEach((item: any) => {
      deptIds += item.dept_id + ',';
      deptNames += item.name + ',';
    });
    deptIds = deptIds.substring(0, deptIds.length - 1);
    deptNames = deptNames.substring(0, deptNames.length - 1);
    this.searchData.fields = {};
    this.searchData.fields.name = deptNames;
    this.searchData.fields.id = deptIds;
    this.searchData.fields.hasSubCustomerDept = this.cusDeptHasSub;
    this.changeData();
    // this.formAdd.userDeptName = this.formAdd.userDept.name;
  }
  private handleCancelDialogDeptLevel() {
    // this.formAdd.userDept = null;
    // this.searchData.fields = {};
    this.tmpSelcetedDeptLevel = null
    this.dialogDeptLevelVisible = false;
  }



  // 故障
  private faultType = "1";
  private faultReadonly = false;
  private faultVisible = false;
  @Watch("faultVisible")
  getFaultVisible(val: boolean) {
    if (val) {
      this.faultReadonly = true;
    } else {
      this.faultReadonly = false;
    }
  }
  private faultSelected(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
    // switch (parseInt(val.type)) {
    //   case 1:
    //     this.orderForm.faultType = val.name;
    //     this.orderForm.faultTypeId = val.id;
    //     break;
    //   case 2:
    //     this.orderForm.faultPhenomenon = val.name;
    //     this.orderForm.faultPhenomenonId = val.id;
    //     break;
    // }
  }
  private faultDialogClose(val: any) {
    this.faultVisible = val;
  }
  private clearFault() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }

  // 安装来源
  private installReadonly = false
  private installVisible = false;
  @Watch("installVisible")
  getInstallVisible(val: boolean) {
    if (val) {
      this.installReadonly = true;
    } else {
      this.installReadonly = false;
    }
  }
  private installSubmit(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.searchData.fields.orderType = {
      label: "安装",
      value: 3,
    };
    this.changeData();
    this.installVisible = false;
    // this.orderForm.installSource = val;
    // this.orderForm.orderType = {
    //   label: "安装",
    //   value: 3,
    // };
  }
  private installClose(val: any) {
    this.installVisible = val;
  }
  private clearInstal() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.searchData.fields.orderType = ''
    this.changeData();
  }

  // 选择品牌类型
  private brandProductModelVisible = false;
  private brandProductModelReadonly = false;
  @Watch("brandProductModelVisible")
  getBrandProductModelVisible(val: boolean) {
    if (val) {
      this.brandProductModelReadonly = true;
    } else {
      this.brandProductModelReadonly = false;
    }
  }
  clearBrandProductModel() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.brandId = '';
    this.searchData.fields.brandName = '';
    this.searchData.fields.productId = '';
    this.searchData.fields.productName = '';
    this.searchData.fields.modelId = '';
    this.searchData.fields.modelName = '';
    this.changeData();
  }
  selectBrandProductModel(value: any) {
    let showname = value.brand_name;
    if (value.product_id) {
      showname += "/" + value.product_name;
      if (value.model_id) {
        showname += "/" + value.model_name;
      }
    }
    this.searchData.fields = {};
    this.searchData.fields.name = showname;
    this.searchData.fields.brandId = value.brand_id;
    this.searchData.fields.brandName = value.brand_name;
    this.searchData.fields.productId = value.product_id;
    this.searchData.fields.productName = value.product_name;
    this.searchData.fields.modelId = value.model_id;
    this.searchData.fields.modelName = value.model_name;
    this.changeData();
  }
  closeBrandProductModel(val: any) {
    this.brandProductModelVisible = val;
  }

  // 客户
  private customerVisible = false;
  private customerReadonly = false;
  private customerHasBranch = false;
  private selectedCustomer: any = null;
  // private tmpSelectedCustomer: any = null;
  @Watch("customerVisible")
  getCustomerVisible(val: boolean) {
    if (val) {
      this.customerReadonly = true;
    } else {
      this.customerReadonly = false;
    }
  }
  showCustomerHandle() {
    this.customerVisible = true;
    if (!(this.searchData.fields && this.searchData.fields.name && this.searchData.fields.name.length > 0)) {
      this.selectedCustomer = null;
    }
    // this.tmpSelectedCustomer = this.selectedCustomer ? [...this.selectedCustomer] : null;
  }

  private customerClose() {
    // this.tmpSelectedCustomer = null;
    this.customerVisible = false;
  }

  private clearCustomer() {
    this.selectedCustomer = null;
    // this.tmpSelectedCustomer = null;
    this.searchData.fields = {};
    this.searchData.fields.id = '';
    this.searchData.fields.name = '';
    this.searchData.fields.companyLevel = '';
    this.searchData.fields.hasBranch = false;
    this.changeData();
  }
  private handleChangeCustomerHasBranch(value: boolean) {
    this.searchData.fields.hasBranch = value;
    this.changeData();
  }
  private handleConfirmCustomer(val:any) {
    // this.selectedCustomer = this.tmpSelectedCustomer ? [...this.tmpSelectedCustomer] : null;
    if(val && val.length>0){
      this.selectedCustomer = val.map((item: any) => {
        return {
          customer_company_id: item.customer_company_id,
          customer_user_id: item.customer_user_id,
          customer_type: item.customer_type,
          name: item.name,
          id: item.customer_company_id ? item.customer_company_id : item.customer_user_id,
        }
      });
    }
    this.customerVisible = false;
    let customerIds = '';
    let customerNames = '';
    let customerLevels = '';
    if (this.selectedCustomer && this.selectedCustomer.length > 0) {
      this.selectedCustomer.forEach((item: any) => {
        let customerId = "";
        if (parseInt(item.customer_type) === 1) {
          customerId = item.customer_company_id;
        } else {
          customerId = "p" + item.customer_user_id;
        }
        customerIds += customerId + ',';
        customerNames += item.name + ',';
        customerLevels += item.company_level + ',';
      });
      customerIds = customerIds.substring(0, customerIds.length - 1);
      customerNames = customerNames.substring(0, customerNames.length - 1);
      customerLevels = customerLevels.substring(0, customerLevels.length - 1);
    }

    this.searchData.fields = {};
    this.searchData.fields.id = customerIds;
    this.searchData.fields.name = customerNames;
    this.searchData.fields.hasBranch = this.customerHasBranch;
    this.searchData.fields.companyLevel = customerLevels;
    this.changeData();
  }


  // 标签
  private tagReadonly = false;
  private tagVisible = false
  @Watch("tagVisible")
  getTagVisible(val: boolean) {
    if (val) {
      this.tagReadonly = true;
    } else {
      this.tagReadonly = false;
    }
  }
  private closeTagHandle(value:boolean) {
    this.tagVisible = value;
  }
  private confirmTagHandle(val:any) {
    this.tagVisible = false;
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.tags_id;
    this.changeData();
  }
  private clearTag() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }

  // 选择工程师
  private selectedEngineervisible = false;
  private selectedEngineervisibleReadonly = false;
  @Watch("selectedEngineervisible")
  getSelectedEngineervisible(val: boolean) {
    if (val) {
      this.selectedEngineervisibleReadonly = true;
    } else {
      this.selectedEngineervisibleReadonly = false;
    }
  }
  private closeEngineer(value:boolean) {
    this.selectedEngineervisible = value;
  }
  private confirmEngineerHandle(val:any) {
    this.tagVisible = false;
    this.searchData.fields = {};
    this.searchData.fields.name = val.user_name;
    this.searchData.fields.id = val.user_id;
    this.changeData();
  }
  private clearEngineer() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }
  private yy = new Date().getFullYear();
  private mm = new Date().getMonth();
  private dd = new Date().getDate();
  private reportFinishTimeChange(val: any) {
    if (this.searchData.fields[1] - this.searchData.fields[0] > this.getManyDays() * 24 * 60 * 60 * 1000) {
      this.showErrorMsg("支持一年内搜索");
      if (this.viewType === ViewType.ORDER_SERVICER_ALL || this.viewType === ViewType.ORDER_SERVICER_COMPLETED) {
        this.$set(this.searchData, 'fields',
          [new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime() - this.getManyDays() * 24 * 60 * 60 * 1000, new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime()]
        )
      } else {
        this.$set(
          this.searchData, 'fields',
          []
        )
      }

      return
    }
    this.changeData();
  }

  private changeData() {
    this.$emit('receiveData', this.searchData);
  }

  private keyupHandle() {
    this.$emit('receiveData', this.searchData, true);
  }
  private getManyDays() {
    let yyyy = 365;
    let y = new Date(this.searchData[1]).getFullYear();
    let flag = y % 400 === 0 || (y % 4 === 0 && y % 100 !== 0);
    if (flag) {
      yyyy = 366;
    }
    return yyyy;
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
}
